<div class="doughnut-chart" fxFlex="1 1" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch">
	<canvas #doughnutChart fxFlex="1 1" fxFlex.xs="auto"></canvas>
</div>
